export interface Rect {
    top: number;
    left: number;
    width: number;
    height: number;
}

export interface Offset {
    top: number;
    left: number;
}

export interface PositionObject {
    direction: string | undefined;
    align: string | undefined;
}

export interface DistanceToHorizontalBorders {
    toRight: number;
    toLeft: number;
}

export class PopupHelper {
    public static getElementAbsoluteRect(element: HTMLElement): Rect {
        const rect = this.getElementRelativeRect(element);
        return this.convertRectToAbsolute(rect);
    }

    public static isAbsoluteRectTopUnderTopBorder(rect: Rect): boolean {
        const windowRelativeRect = this.getWindowRelativeRect();
        const windowAbsoluteRect = this.convertRectToAbsolute(windowRelativeRect);

        return rect.top > windowAbsoluteRect.top;
    }

    public static getDistanceToHorizontalBorders(rect: Rect): DistanceToHorizontalBorders {
        const windowRelativeRect = this.getWindowRelativeRect();
        const windowAbsoluteRect = this.convertRectToAbsolute(windowRelativeRect);

        return {
            toRight: windowAbsoluteRect.left + windowAbsoluteRect.width - (rect.left + rect.width),
            toLeft: rect.left - windowAbsoluteRect.left,
        };
    }

    private static getElementRelativeRect(element: HTMLElement) {
        const rect = element.getBoundingClientRect();

        return {
            top: rect.top,
            left: rect.left,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top,
        };
    }

    private static getWindowRelativeRect(): Rect {
        return {
            top: 0,
            left: 0,
            width: this.getViewProperty(x => x.clientWidth) || window.innerWidth,
            height: this.getViewProperty(x => x.clientHeight) || window.innerHeight,
        };
    }

    private static convertRectToAbsolute(rect: Rect): Rect {
        const offset = this.getAbsoluteOffset();

        return {
            top: rect.top + offset.top,
            left: rect.left + offset.left,
            width: rect.width,
            height: rect.height,
        };
    }

    private static getAbsoluteOffset(): Offset {
        const scrollTop = window.pageYOffset || this.getViewProperty(x => x.scrollTop);
        const scrollLeft = window.pageXOffset || this.getViewProperty(x => x.scrollLeft);

        const clientTop = this.getViewProperty(x => x.clientTop);
        const clientLeft = this.getViewProperty(x => x.clientLeft);

        const top = scrollTop - clientTop;
        const left = scrollLeft - clientLeft;

        return {
            top: top,
            left: left,
        };
    }

    private static getViewProperty(getProperty: (e: HTMLElement) => number): number {
        const views = [document.documentElement, document.body];
        return views.map(x => x && getProperty(x)).find(Boolean) || 0;
    }
}
